module.exports = __webpack_public_path__ + "static/img/son7.f703d107.png";